import { ButtonsPrimary } from '../../ComponentApp/buttoms';
import {
  RescueBodyContainer,
  RescueContentFund,
  SectionSelectRescue,
  SelectContent,
  TitleAndAmountContainer,
  TitleContainerRescue,
  TitleSectionRescue,
  TitleTextRescue,
} from '../../portfolio/rescuePortfolio/RescueComponent';
import ValueSection from '../../portfolio/rescuePortfolio/ValueSection';
import SelectRescueItemFund from './SelectRescueItemFund';

const CardsContainerRescueFund = ({
  rescueType,
  radiobtnChange,
  investmentSelected,
  amount2,
  addamount2,
  mountEqual,
  cuotas,
  disabled,
  handleGoToConfirm,
  marketValue,
  typeProduct,
}) => {
  return (
    <RescueBodyContainer>
      <TitleAndAmountContainer>
        <TitleContainerRescue>
          <TitleTextRescue>Rescatar inversión</TitleTextRescue>
        </TitleContainerRescue>
        <ValueSection marketValue={marketValue} typeProduct={typeProduct} />
      </TitleAndAmountContainer>

      <RescueContentFund>
        <SelectContent>
          <TitleSectionRescue>¿Cuánto deseas rescatar?</TitleSectionRescue>
          <SectionSelectRescue>
            <SelectRescueItemFund
              rescueType={rescueType}
              radiobtnChange={radiobtnChange}
              investmentSelected={investmentSelected}
              amount2={amount2}
              addamount2={addamount2}
              mountEqual={mountEqual}
              cuotas={cuotas}
              disabled={disabled}
              handleGoToConfirm={handleGoToConfirm}
            />
          </SectionSelectRescue>
        </SelectContent>

        <ButtonsPrimary
          disabled={disabled}
          onClick={handleGoToConfirm}
          sx={{
            mt: 3,
            mr: 1,
          }}
          name={'Rescate fondos de inversión'}
        />
      </RescueContentFund>
    </RescueBodyContainer>
  );
};

export default CardsContainerRescueFund;
